import React, { HTMLAttributeAnchorTarget, useContext } from 'react';
import { ThemeProvider } from 'emotion-theming';
import { Link } from 'react-router';
import { genThemedStyled, Theme, ThemeContext } from '../../utilities/theme';
import { ColorCodes, colorsForTheme } from '../../foundations/color';
import { FUTURO_TYPEFACES as F } from '../../foundations/font';
import S from '../../foundations/size';
import { Icon } from '../../foundations';

export type HelpDropdownProps = {
  to?: string;
  href?: string;
  target?: HTMLAttributeAnchorTarget;
  text: string;
  external?: boolean;
};

const getTheme = (theme: Theme): themeStyles => {
  const colors = colorsForTheme(theme);
  const colorThemes = {
    textColor: colors.SPACE,
    textHoverColor: colors.SWEET_ORANGE,
    textHoverBGColor: colors.LIGHT_PEACH,
  };
  return colorThemes;
};

type themeStyles = {
  textColor: ColorCodes;
  textHoverColor: ColorCodes;
  textHoverBGColor: ColorCodes;
};

const ThemeStyled = genThemedStyled<themeStyles>();

const NavA = ThemeStyled.a(
  p => ({
    display: 'flex',
    gap: S.XXXS,
    color: p.theme.textColor,
    marginLeft: S.S,
    marginRight: S.S,
    padding: S.XXS,
    cursor: 'pointer',
    ':hover': {
      color: p.theme.textHoverColor,
      backgroundColor: p.theme.textHoverBGColor,
      borderRadius: S.XXXS,
    },
    ':active': {
      color: p.theme.textHoverColor,
      backgroundColor: p.theme.textHoverBGColor,
      borderRadius: S.XXXS,
    },
  }),
  F.LABEL_SMALL_BOLD
);

const NavLink = ThemeStyled(Link)(
  p => ({
    display: 'flex',
    gap: S.XXXS,
    color: p.theme.textColor,
    marginLeft: S.S,
    marginRight: S.S,
    padding: S.XXS,
    cursor: 'pointer',
    ':hover': {
      color: p.theme.textHoverColor,
      backgroundColor: p.theme.textHoverBGColor,
      borderRadius: S.XXXS,
    },
    ':active': {
      color: p.theme.textHoverColor,
      backgroundColor: p.theme.textHoverBGColor,
      borderRadius: S.XXXS,
    },
  }),
  F.LABEL_SMALL_BOLD
);

export const HeaderDropdownItem = (props: HelpDropdownProps) => {
  const { to, href, text, target, external } = props;
  const themeStyle = getTheme(useContext(ThemeContext));
  return (
    <ThemeProvider theme={themeStyle}>
      {to && <NavLink to={to}>{text}</NavLink>}
      {href && (
        <NavA href={href} target={target}>
          {text}
          {external && <Icon name="sExternal" inheritFill />}
        </NavA>
      )}
    </ThemeProvider>
  );
};

export default HeaderDropdownItem;
